import React, { useState, useRef, useEffect } from 'react';
import { FaSearch, FaPhone, FaEnvelope, FaBars, FaTimes, FaUser, FaChevronDown } from 'react-icons/fa';
import './navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);




  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setIsDropdownOpen(false);
    }
  };

  // FIXED: Add event parameter and stop propagation
  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation(); // This prevents the event from bubbling up
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <div className="contact-item">
  <a href="tel:+94701707707" className="contact-link">
    <FaPhone className="contact-icon" />
    <span> &nbsp; +94 70 170 7707</span>
  </a>
</div>

<div className="contact-item">
  <a href="mailto:info@retionzcabs.lk" className="contact-link">
    <FaEnvelope className="contact-icon" />
    <span> &nbsp; info@retionzcabs.lk</span>
  </a>
</div>

            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            {/* Logo */}
            <div className="logo">
              <h2 className="logo-text">Retionz Cabs</h2>
              <span className="logo-tagline">Your Reliable Ride</span>
            </div>

            {/* Navigation Links */}
            <div className={`nav-links ${isMenuOpen ? 'nav-links-active' : ''}`}>

     

              <a href="/" className="nav-link" onClick={closeMenu}>
                Home
              </a>

              <a href="/bookings" className="nav-link" onClick={closeMenu}>
                Book Now
              </a>
              
              {/* Services Dropdown - FIXED VERSION */}
              <div className="dropdown" ref={dropdownRef}>
                <button 
                  className="nav-link dropdown-btn" 
                  onClick={toggleDropdown}
                  type="button"
                >
                  Our Services
                  <FaChevronDown className={`dropdown-icon ${isDropdownOpen ? 'rotate' : ''}`} />
                </button>
                <div className={`dropdown-menu ${isDropdownOpen ? 'dropdown-active' : ''}`}>
                  <a href="/airport-tour" className="dropdown-link" onClick={closeMenu}>
                    Airport Transfers
                  </a>
                  <a href="/city-rides" className="dropdown-link" onClick={closeMenu}>
                    City Rides
                  </a>
                  <a href="/outstation-tour" className="dropdown-link" onClick={closeMenu}>
                    Outstation Tours
                  </a>
                  <a href="/wedding-tour" className="dropdown-link" onClick={closeMenu}>
                    Wedding Services
                  </a>
                  <a href="/short-long-term" className="dropdown-link" onClick={closeMenu}>
                    Short & Long Term Rentals
                  </a>
                </div>
              </div>
              <a href="/packages" className="nav-link" onClick={closeMenu}>
                Packages
              </a>
             {/* <a href="/gallery" className="nav-link" onClick={closeMenu}>
                Gallery
              </a> */}
              <a href="/aboutus" className="nav-link" onClick={closeMenu}>
                About Us
              </a>
              <a href="/contactus" className="nav-link" onClick={closeMenu}>
                Contact Us
              </a>
            </div>

           

            {/* Mobile Menu Button */}
            <button className="mobile-menu-btn" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </nav>

      {/* Overlay for mobile menu */}
      {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
    </>
  );
}

export default Navbar;